import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef, AfterContentChecked } from "@angular/core";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { SetValid } from "src/classes/Common/SetValid";
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { CustCard_5 } from "src/classes/Customers/CustCard_5";
import { trigger, state, style, transition, animate, keyframes } from "@angular/animations";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { MessageService } from "primeng/api";
import { ControlsService } from "src/app/services/Common/controls.service";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { NGXLogger } from "ngx-logger";
import { Subscription } from "rxjs";

interface SaparData {
    saparId: number;
    saparName: string;
}

interface ImportanceData {
    id: number;
    textWarn: string;
}

@Component({
    selector: "app-custcardview5",
    templateUrl: "./custcardview5.component.html",
    styleUrls: ["./custcardview5.component.css"],
    animations: [
        trigger("panelAnimation", [
            state("added", style({ opacity: 1, height: "*" })),
            transition("void => void", [
                animate("1s ease-in-out", keyframes([
                    style({ opacity: 1, height: "*", overflow: "hidden" }),
                    style({ opacity: 0, height: 0, overflow: "hidden" })
                ]))
            ]),
            transition("void => *", [
                animate("1s ease-in-out", keyframes([
                    style({ opacity: 0, height: 0, overflow: "hidden", offset: 0 }),
                    style({ opacity: 1, height: "*", overflow: "hidden", offset: 0.999 }),
                    style({ opacity: 1, height: "*", overflow: "unset", offset: 1 })
                ]))
            ]),
            transition("* => void", [
                animate("1s ease-in-out", keyframes([
                    style({ opacity: 1, height: "*", overflow: "hidden" }),
                    style({ opacity: 0, height: 0, overflow: "hidden" })
                ]))
            ]),
        ]),
    ],
    providers: [HttpServiceCustomer]
})
export class Custcardview5Component implements OnInit, OnDestroy, AfterContentChecked {
    customerin: CustomerIn = new CustomerIn();
    receivedvalid: SetValid = new SetValid();

    isNotificationsAnimationDisabled: boolean = true;

    previousTab: number = 57;

    custcard_5: CustCard_5[];
    notificationTab: number = 0;

    saveData: boolean = false;
    componentHasChanged: boolean = false;

    pressedElement: CustCard_5;
    isLoaderVisible: boolean = false;
    isConfirmDialogVisible: boolean = false;
    confirmDialogType: string = null;
    confirmDialogText: string;

    isAddingOrEditingComment: boolean = false;
    commentDialogTitle: string;
    newCommentTitle: string = "";
    newCommentText: string = "";

    colors: string[] = ["#FBA9A9", "#FFE57D", "#A5FFE4", "#FFDAAF", "#DADADA", "#A1E9FF"];
    backgroundColors: string[] = ["#FFC8C8", "#FFF6D1", "#C7FFEE", "#FFE5C7", "#E6E6E6", "#C7F2FF"];
    isColorsVisible: boolean = false;
    chosenColor: string = "#FFE57D";

    workers: SaparData[];
    importance: ImportanceData[];
    workerOption: number = 0;
    importanceOption: number = 0;

    isAddingOrEditingTask: boolean = false;
    taskDialogTitle: string;
    newTaskText: string = "";
    newTaskPeriodType: number = 1;
    newTaskTimeValue: number = 1;
    newTaskDate: Date = new Date();
    minDate: Date = new Date();


    actionSelection:number=0;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    setCustcard5Subscription: Subscription;

    @Input() customerId: number = 0;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private custCardTabService: CustCardTabService,
        private changeDetector: ChangeDetectorRef,
        private dynamicDialogService: DynamicDialogService,
        private messageService: MessageService,
        private controlsService: ControlsService,
        private logger: NGXLogger
    ) {
        custCardTabService.notificationTabChanged.subscribe((tabIndex: number) => this.changeNotificationTab(tabIndex));
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onTabChange(tabIndex));
    }

    ngOnInit(): void {
        this.customerin.customer_id = this.customerId;

        // Get the list of notes and assignments
        this.httpServiceCustomer.getCustCard_5(this.customerin)
            .subscribe((data: CustCard_5[]) => {
                this.custcard_5 = data;

                setTimeout(() => {
                    this.isNotificationsAnimationDisabled = false;
                }, 0);

                this.custCardTabService.isCommentsExist = this.hasComments();
                this.custCardTabService.isTasksExist = this.hasTasks();

                console.log("Count of notes and assignments: " + this.custcard_5.length);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.httpServiceCustomer.getWorkers()
            .subscribe((data: SaparData[]) => {
                this.workers = data.filter((worker: SaparData) => worker.saparName != "בחר");
                this.workerOption = this.workers[0].saparId;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        this.httpServiceCustomer.getCustomWarn_Importance()
            .subscribe((data: ImportanceData[]) => {
                this.importance = data;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngAfterContentChecked(): void {
        this.changeDetector.detectChanges();
    }

    ngOnDestroy(): void {
        this.custCardTabService.tabIndex = 57;
        this.dynamicDialogService.closeDialog();
        this.saveNotesAssignments();
    }

    onTabChange(tabIndex: number): void {
        if (tabIndex == 57) {
            this.saveData = false;
        }

        if (this.previousTab == 57) {
            this.dynamicDialogService.closeDialog();
            this.saveNotesAssignments();
        }
        this.previousTab = tabIndex;
    }

    changeNotificationTab(tabIndex?: number): void {
        if (tabIndex != undefined) {
            if (tabIndex != 2) {
                this.notificationTab = tabIndex;
            }
        }
        else {
            this.notificationTab = this.notificationTab ? 0 : 1;
        }

        this.isNotificationsAnimationDisabled = true;
        setTimeout(() => {
            this.isNotificationsAnimationDisabled = false;
        }, 0);
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    getNotificationsArray(): CustCard_5[] {
        if (this.custcard_5) {
            return this.sortCustCard5().filter((element: CustCard_5) => (this.notificationTab ? !element.isComment : element.isComment) && !element.isDeleted);
        }
    }

    hasComments(): boolean {
        if (this.custcard_5) {
            return this.custcard_5.filter((element: CustCard_5) => element.isComment && !element.isDeleted).length != 0;
        }
    }

    hasTasks(): boolean {
        if (this.custcard_5) {
            return this.custcard_5.filter((element: CustCard_5) => !element.isComment && !element.isDeleted).length != 0;
        }
    }

    getBackgroundColor(color: string): string {
        return this.backgroundColors[this.colors.findIndex((element: string) => element == color)];
    }

    isReadMoreButtonVisible(element: HTMLElement): boolean {
        return element.children[1].scrollHeight != element.children[1].clientHeight;
    }

    addNewButtonClick(): void {
        if (!this.notificationTab) {
            this.newCommentTitle = "";
            this.newCommentText = "";
            this.chosenColor = "#FFE57D";
            this.commentDialogTitle = "הערה חדשה";
            this.isAddingOrEditingComment = true;
        }
        else {
            this.workerOption = this.workers[0].saparId;
            this.newTaskText = "";
            this.importanceOption = 0;
            this.newTaskPeriodType = 1;
            this.newTaskTimeValue = 1;
            this.newTaskDate = new Date();
            this.taskDialogTitle = "בחר תאריך וזמן להקפצת המטלה";
            this.isAddingOrEditingTask = true;
        }
    }

    isNewCommentTextEmpty(): boolean {
        return this.newCommentText.trim() == "";
    }

    colorButtonClick(): void {
        this.isColorsVisible = true;
    }

    stopPropagation(event: Event): void {
        event.stopPropagation();
    }

    closeColorPicker(color?: string): void {
        if (color) {
            this.chosenColor = color;
        }
        this.isColorsVisible = false;
    }

    closeAddOrEditCommentDialog(isAccepted: boolean): void {
        if (isAccepted) {
            if (this.commentDialogTitle != "הערה חדשה") {
                this.pressedElement.title = this.newCommentTitle.trim() || "הערת לקוח/ה";
                this.pressedElement.comments = this.newCommentText.trim();
                this.pressedElement.color = this.chosenColor;

                this.showMessage("success", "הערה עודכנה בהצלחה.");
            }
            else {
                const maxId: number = this.custcard_5.length ? this.custcard_5.reduce((accumulator, current) => {
                    return accumulator.ind > current.ind ? accumulator : current;
                }).ind + 1 : 1;

                let registrationDate: Date | (string | number)[] | string = new Date();
                registrationDate = [registrationDate.getDate(), registrationDate.getMonth() + 1, registrationDate.getFullYear()];

                if (+registrationDate[0] < 10) {
                    registrationDate[0] = "0" + registrationDate[0];
                }
                if (+registrationDate[1] < 10) {
                    registrationDate[1] = "0" + registrationDate[1];
                }

                registrationDate = registrationDate.join("/");

                this.custcard_5.push({
                    customerID: +this.customerin.customer_id,
                    ind: maxId,
                    title: this.newCommentTitle.trim() || "הערת לקוח/ה",
                    comments: this.newCommentText.trim(),
                    dateRegistration: registrationDate,
                    isChecked: false,
                    color: this.chosenColor,
                    isComment: true,
                    orderID: 0,
                    isDeleted: false,
                    dateRegistrationText: "נוצר ב",
                    dateRegistrationInSideText: registrationDate
                });

                this.showMessage("success", "הערה נוצרה בהצלחה.");
            }

            this.custCardTabService.isCommentsExist = true;
        }

        this.isAddingOrEditingComment = false;
    }

    isSaveTaskButtonDisabled(): boolean {
        let newDate: string[] | number = this.getTaskDate("date", true).split("/");
        let newTime: string[] | number = this.getTaskDate("time", true).split(":");

        newDate = new Date(+newDate[2], +newDate[1] - 1, +newDate[0], +newTime[0], +newTime[1]).getTime();

        return newDate < new Date().getTime();
    }

    timeValueDecrement(): void {
        if (this.newTaskTimeValue > 1) {
            this.newTaskTimeValue--;
        }
    }

    timeValueIncrement(): void {
        this.newTaskTimeValue++;
    }

    datepickerBackspaceEvent(): void {
        this.newTaskDate = null;
    }

    periodTypeChange(): void {
        this.minDate = new Date();
        this.newTaskDate = new Date();
        this.newTaskTimeValue = 1;
    }

    onRangeFocus(target: HTMLInputElement): void {
        target.select();
    }

    onRangeChange(model: string, eventTarget: HTMLInputElement, minValue?: number, maxValue?: number): void {
        this[model] = +this[model].replace(/[^0-9*#]/g, "");

        if (minValue && this[model] < minValue) {
            this[model] = minValue;
        }
        if (maxValue && this[model] > maxValue) {
            this[model] = maxValue;
        }

        eventTarget.value = this[model];
    }

    getTaskDate(type: string, isVisibleToClient: boolean): string {
        let newDate: Date = new Date(this.newTaskDate);

        if (newDate) {
            if (this.newTaskPeriodType == 1) {
                newDate.setMinutes(newDate.getMinutes() + this.newTaskTimeValue);
            }
            else if (this.newTaskPeriodType == 2) {
                newDate.setHours(newDate.getHours() + this.newTaskTimeValue);
            }
            else if (this.newTaskPeriodType == 3) {
                newDate.setDate(newDate.getDate() + this.newTaskTimeValue);
            }
            else if (this.newTaskPeriodType == 4) {
                newDate.setDate(newDate.getDate() + (7 * this.newTaskTimeValue));
            }
            else if (this.newTaskPeriodType == 5) {
                newDate.setMonth(newDate.getMonth() + this.newTaskTimeValue);
            }

            if (type == "time") {
                return [(newDate.getHours() > 9 ? "" : "0") + newDate.getHours(), (newDate.getMinutes() > 9 ? "" : "0") + newDate.getMinutes()].join(":");
            }
            else if (type == "date") {
                if (!isVisibleToClient && newDate.getTime() < new Date().getTime()) {
                    return "מטלה לא פעילה";
                }
                return [(newDate.getDate() > 9 ? "" : "0") + newDate.getDate(), (newDate.getMonth() + 1 > 9 ? "" : "0") + (newDate.getMonth() + 1), newDate.getFullYear()].join("/");
            }
        }
        return "";
    }

    getDateRegistrationText(date: string): string {
        let newDate: Date = new Date();
        let dateArray: string[] = date.split("/");

        if (+dateArray[2] == newDate.getFullYear() && +dateArray[1] == newDate.getMonth() + 1 && +dateArray[0] == newDate.getDate()) {
            return "תקפוץ היום ב";
        }
        else if (+dateArray[2] == newDate.getFullYear() && +dateArray[1] == newDate.getMonth() + 1 && +dateArray[0] == newDate.getDate() + 1) {
            return "תקפוץ מחר ב";
        }
        return "תקפוץ ב";
    }

    closeAddOrEditTaskDialog(isAccepted: boolean): void {
        if (isAccepted) {
            let newImportance: string = this.importance.find((element: ImportanceData) => element.id == this.importanceOption).textWarn;

            if (this.importanceOption == 0) {
                newImportance = "מטלה קופצת";
            }
            else {
                newImportance = "מטלה קופצת: " + newImportance;
            }

            let newDateText: string;

            if (this.getDateRegistrationText(this.getTaskDate("date", false)) == 'תקפוץ ב' || this.getTaskDate("date", false) == 'מטלה לא פעילה') {
                newDateText = this.getTaskDate("date", false);
            }
            else {
                newDateText = this.getTaskDate("time", false);
            }

            if (this.taskDialogTitle == "ערוך מטלה") {
                this.pressedElement.title = newImportance;
                this.pressedElement.comments = this.newTaskText.trim();
                this.pressedElement.importance = this.importanceOption;
                this.pressedElement.dateRegistration = this.getTaskDate("date", true);
                this.pressedElement.dateRegistrationText = this.getDateRegistrationText(this.getTaskDate("date", true));
                this.pressedElement.dateRegistrationInSideText = newDateText;
                this.pressedElement.fromTime = this.getTaskDate("time", false);
                this.pressedElement.timeVal = this.newTaskTimeValue;
                this.pressedElement.periodTypeId = +this.newTaskPeriodType;
                this.pressedElement.saparID = this.workerOption;
                this.pressedElement.inAction = this.getTaskDate("date", false) != "מטלה לא פעילה";

                this.showMessage("success", "מטלה עודכנה בהצלחה.");
            }
            else if (this.taskDialogTitle == "החלף הערה למטלה") {
                this.pressedElement.title = newImportance;
                this.pressedElement.comments = this.newTaskText.trim();
                this.pressedElement.importance = this.importanceOption;
                this.pressedElement.dateRegistration = this.getTaskDate("date", true);
                this.pressedElement.dateRegistrationText = this.getDateRegistrationText(this.getTaskDate("date", true));
                this.pressedElement.dateRegistrationInSideText = newDateText;
                this.pressedElement.fromTime = this.getTaskDate("time", false);
                this.pressedElement.timeVal = this.newTaskTimeValue;
                this.pressedElement.periodTypeId = +this.newTaskPeriodType;
                this.pressedElement.saparID = this.workerOption;
                this.pressedElement.inAction = this.getTaskDate("date", false) != "מטלה לא פעילה";
                this.pressedElement.isComment = false;

                this.showMessage("success", "מטלה נוצרה בהצלחה.");
            }
            else {
                const maxId: number = this.custcard_5.length ? this.custcard_5.reduce((accumulator, current) => {
                    return accumulator.ind > current.ind ? accumulator : current;
                }).ind + 1 : 1;

                this.custcard_5.push({
                    customerID: +this.customerin.customer_id,
                    ind: maxId,
                    title: newImportance,
                    comments: this.newTaskText.trim(),
                    dateRegistration: this.getTaskDate("date", true),
                    isComment: false,
                    orderID: 0,
                    isDeleted: false,
                    importance: this.importanceOption,
                    dateRegistrationText: this.getDateRegistrationText(this.getTaskDate("date", true)),
                    dateRegistrationInSideText: newDateText,
                    fromTime: this.getTaskDate("time", false),
                    timeVal: this.newTaskTimeValue,
                    periodTypeId: +this.newTaskPeriodType,
                    saparID: this.workerOption,
                    inAction: this.getTaskDate("date", false) != "מטלה לא פעילה"
                });

                this.showMessage("success", "מטלה נוצרה בהצלחה.");
            }

            this.custCardTabService.isTasksExist = true;
            this.custCardTabService.isCommentsExist = this.hasComments();
        }

        this.isAddingOrEditingTask = false;
    }

    editExistingComment(item: CustCard_5): void {
        this.commentDialogTitle = "ערוך הערה";
        this.newCommentTitle = item.title;
        this.newCommentText = item.comments;
        this.chosenColor = item.color;
        this.pressedElement = item;
        this.isAddingOrEditingComment = true;
    }

    editExistingTask(item: CustCard_5): void {
        let newDateText: string[] = item.dateRegistration.split("/");
        let newTimeText: string[] = item.fromTime.split(":");

        let newDate = new Date(+newDateText[2], +newDateText[1] - 1, +newDateText[0], +newTimeText[0], +newTimeText[1])

        if (item.periodTypeId == 1) {
            newDate.setMinutes(newDate.getMinutes() - item.timeVal);
        }
        else if (item.periodTypeId == 2) {
            newDate.setHours(newDate.getHours() - item.timeVal);
        }
        else if (item.periodTypeId == 3) {
            newDate.setDate(newDate.getDate() - item.timeVal);
        }
        else if (item.periodTypeId == 4) {
            newDate.setDate(newDate.getDate() - (7 * item.timeVal));
        }
        else if (item.periodTypeId == 5) {
            newDate.setMonth(newDate.getMonth() - item.timeVal);
        }

        this.workerOption = item.saparID;
        this.importanceOption = item.importance;
        this.newTaskText = item.comments;
        this.newTaskPeriodType = item.periodTypeId;
        this.newTaskTimeValue = item.timeVal;
        this.newTaskDate = newDate;
        this.taskDialogTitle = "ערוך מטלה";
        this.pressedElement = item;
        this.isAddingOrEditingTask = true;
    }

    pinButtonClick(item: CustCard_5): void {
        this.pressedElement = item;
        
        if (!item.isChecked) {
            this.actionSelection=1;
            this.confirmDialogText = "האם להפוך את ההערה הזו לראשית?\n(תהיה הראשונה מלמעלה ברשימה)";
        }
        else {
           
            this.confirmDialogText = "האם לבטל את סימון ההערה כראשית?\n(לא תהיה הראשונה מלמעלה ברשימה)";
        }

        this.confirmDialogType = "pin";
        this.isConfirmDialogVisible = true;
    }

    crossButtonClick(item: CustCard_5): void {
        this.pressedElement = item;

        if (item.isComment) {
            this.actionSelection=2;
            this.confirmDialogText = "האם אתם בטוחים במחיקת הערה?";
        }
        else {
            this.actionSelection=2;
            this.confirmDialogText = "האם אתם בטוחים במחיקת מטלה?";
        }

        this.confirmDialogType = "close";
        this.isConfirmDialogVisible = true;
    }

    closeConfirmDialog(isAccepted: boolean): void {
        if (isAccepted) {
            if (this.confirmDialogType == "pin") {
                this.isLoaderVisible = true;

                setTimeout(() => {
                    if (this.pressedElement.isChecked) {
                        this.pressedElement.isChecked = false;
                        this.showMessage("success", "בחירת הערה כקבועה בוטלה.");
                    }
                    else {
                        if (this.custcard_5.find((element: CustCard_5) => element.isChecked)) {
                            this.custcard_5.find((element: CustCard_5) => element.isChecked).isChecked = false;
                        }

                        this.pressedElement.isChecked = true;
                        this.showMessage("success", "נבחרה הערה קבועה.");
                    }

                    this.isLoaderVisible = false;
                }, Math.random() * (800 - 500) + 500);

            }
            else if (this.confirmDialogType == "close") {
                this.pressedElement.isDeleted = true;
                this.pressedElement.isChecked = false;

                this.custCardTabService.isCommentsExist = this.hasComments();
                this.custCardTabService.isTasksExist = this.hasTasks();
                this.showMessage("success", "מטלה נמחקה בהצלחה.");
            }
        }

        this.confirmDialogType = null;
        this.isConfirmDialogVisible = false;
    }

    switchToTask(item: CustCard_5): void {
        this.workerOption = this.workers[0].saparId;
        this.importanceOption = 0;
        this.newTaskText = item.comments;
        this.newTaskPeriodType = 1;
        this.newTaskTimeValue = 1;
        this.newTaskDate = new Date();
        this.minDate = new Date();
        this.taskDialogTitle = "החלף הערה למטלה";
        this.pressedElement = item;
        this.isAddingOrEditingTask = true;
    }

    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    saveNotesAssignments(): void {
        if (this.componentHasChanged) {
            this.saveData = true;

            if (this.setCustcard5Subscription && !this.setCustcard5Subscription.closed) {
                this.setCustcard5Subscription.unsubscribe();
            }

            this.setCustcard5Subscription = this.httpServiceCustomer.setCustCard_5(this.custcard_5)
                .subscribe((res: SetValid) => {
                    this.receivedvalid = res;
                    this.receivedvalid.answer = res.answer;
                    console.log("CastCard_5 data saved: " + this.receivedvalid.answer);
                }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
        }
    }

    sortCustCard5(): CustCard_5[] {
        let resultArray: CustCard_5[] = [];

        if (!this.notificationTab) {
            resultArray = [...this.custcard_5];
            resultArray = resultArray.sort((a: CustCard_5, b: CustCard_5) => {
                let firstDate: string[] | number = a.dateRegistration.split("/");
                firstDate = new Date(+firstDate[2], +firstDate[1] - 1, +firstDate[0]).getTime();
                let secondDate: string[] | number = b.dateRegistration.split("/");
                secondDate = new Date(+secondDate[2], +secondDate[1] - 1, +secondDate[0]).getTime();

                return secondDate - firstDate;
            });

            if (resultArray.findIndex((element: CustCard_5) => element.isChecked) != -1) {
                let checkedElement = resultArray.splice(resultArray.findIndex((element: CustCard_5) => element.isChecked), 1);
                resultArray.unshift(checkedElement[0]);
            }
        }
        else {
            let activeTasks: CustCard_5[] = this.custcard_5.filter((element: CustCard_5) => !element.isComment && element.inAction);
            let inactiveTasks: CustCard_5[] = this.custcard_5.filter((element: CustCard_5) => !element.isComment && !element.inAction);

            activeTasks = activeTasks.sort((a: CustCard_5, b: CustCard_5) => {
                let firstDate: string[] = a.dateRegistration.split("/");
                let firstTime: string[] = a.fromTime.split(":");
                let secondDate: string[] = b.dateRegistration.split("/");
                let secondTime: string[] = b.fromTime.split(":");

                return new Date(+firstDate[2], +firstDate[1] - 1, +firstDate[0], +firstTime[0], +firstTime[1]).getTime() - new Date(+secondDate[2], +secondDate[1] - 1, +secondDate[0], +secondTime[0], +secondTime[1]).getTime();
            });

            inactiveTasks = inactiveTasks.sort((a: CustCard_5, b: CustCard_5) => {
                let firstDate: string[] = a.dateRegistration.split("/");
                let firstTime: string[] = a.fromTime.split(":");
                let secondDate: string[] = b.dateRegistration.split("/");
                let secondTime: string[] = b.fromTime.split(":");

                return new Date(+firstDate[2], +firstDate[1] - 1, +firstDate[0], +firstTime[0], +firstTime[1]).getTime() - new Date(+secondDate[2], +secondDate[1] - 1, +secondDate[0], +secondTime[0], +secondTime[1]).getTime();
            });

            resultArray.push(...activeTasks)
            resultArray.push(...inactiveTasks);
        }

        return resultArray;
    }
}
